<app-header></app-header>
<section id="first-feature" class="mt-4 pt-4">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <h2 style="font-size:45px">Events on OMNI</h2>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container mb-5">
        <div class="col-md-12">

            <div class="row align-items-center">
                <div class="col-md-6 mb-4" *ngFor="let item of eventList">
                    <div class="border">
                        <img [src]="item.bannerImage" class="img-fluid">
                        <h2 class="text-center my-3" [title]="item.title">{{item.title}}</h2>

                        <div class="row p-1">
                            <div class="col-sm-12 col-40">
                                <p><strong>Start time</strong><br>{{item.startTime | date:'MMM d, y | h:mm a'}}</p>
                            </div>
                            <div class="col-sm-12 col-40">
                                <p><strong>End time</strong><br>{{item.endTime | date:'MMM d, y | h:mm a'}}</p>
                            </div>
                            <div class="col-sm-12 col-20 d-flex justify-content-end">
                                <p class="text-nowrap"><strong>Duration</strong><br>{{getDuration(item.duration)}}</p>
                            </div>
                            <div class="col-md-12 mb-2 mt-2 text-center"><a target="_blank" [routerLink]="'/events/'+item.slug"
                                    class="bg-button btn btn-primary flex-grow-1 schedule-demo-btn">{{isEventCompleted(item.endTime) ? 'View Event' : 'Register Now'}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
<hr>
<app-footer></app-footer>